export default "__VITE_ASSET__PSAX7d41__"